export const SEARCH_PLACEHOLDER = 'Search for jewellery...';

/** Image search results PLP route (same-origin; keeps sessionStorage). */
export const IMAGE_SEARCH_PAGE_PATH = '/search/image';

/** Design ID strings returned by the embedding search-image API. */
export type ImageSearchEmbeddingResponse = string[];

/** Image search embedding API — production host for now. */
export const IMAGE_SEARCH_BASE_URL = 'https://www.bluestone.com';
export const IMAGE_SEARCH_PATH = '/embedding/search-image';
export const IMAGE_SEARCH_API_URL = `${IMAGE_SEARCH_BASE_URL}${IMAGE_SEARCH_PATH}`;

export const SEARCHED_FOR_PRODUCT_EVENT_ID = 'searched_for_product';

export function buildSearchedForProductPayload(searchQuery: string): Record<string, unknown> {
  return {
    _eventId: SEARCHED_FOR_PRODUCT_EVENT_ID,
    search_query: searchQuery.trim(),
    search_type: 'regular',
  };
}

export function trackSearchedForProduct(
  analytics: {
    logEventLogger: (payload: Record<string, unknown>) => void;
    trackEvent: (eventName: string, properties?: Record<string, unknown>) => void;
  } | null | undefined,
  searchQuery: string,
): void {
  const trimmed = searchQuery.trim();
  if (!trimmed || !analytics) return;
  analytics.logEventLogger(buildSearchedForProductPayload(trimmed));
  analytics.trackEvent('Product Searched', {
    'Search Keyword': trimmed,
    'Search Query': trimmed,
  });
}
